import { useState, useEffect } from "react";
import "./LoadingEllipses.css";

export default function LoadingEllipses() {
  const [dots, setDots] = useState("");
  const [message, setMessage] = useState("Crafting the perfect show for you...");

  useEffect(() => {
    let messages = [];

    // Fetch messages from YML file
    fetch("/inphinite_loading_messages.yml")
      .then((res) => res.text())
      .then((yamlText) => {
        const lines = yamlText.split("\n");
        messages = lines
          .filter((line) => line.trim().startsWith("-"))
          .map((line) => line.trim().slice(1).trim().replace(/^["']|["']$/g, ""));

        if (messages.length > 0) {
          setMessage(messages[Math.floor(Math.random() * messages.length)]);
        }
      })
      .catch((err) => {
        console.error("Failed to load loading messages:", err);
      });

    const dotsInterval = setInterval(() => {
      setDots((prev) => {
        if (prev === "...") return "";
        return prev + ".";
      });
    }, 400);

    const messageInterval = setInterval(() => {
      if (messages.length > 0) {
        setMessage(messages[Math.floor(Math.random() * messages.length)]);
      }
    }, 3000);

    return () => {
      clearInterval(dotsInterval);
      clearInterval(messageInterval);
    };
  }, []);

  return (
    <div className="loading-container">
      <h2 className="loading-title">
        Generating Setlist
        <span className="loading-dots">{dots}</span>
      </h2>
      <div className="loading-message">{message}</div>
    </div>
  );
}
